// extracted by mini-css-extract-plugin
module.exports = {"button":"index_button__HWNVO","hidden":"index_hidden__hmFPq"};